<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{EventName}}</p>
    </header>
    <section class="modal-card-body" style="min-width: 800px;">
      @for (input of Inputs; track input) {
        <app-field [Label]="input.Label">
          <div class="control">
            @if (input.InputType == 'Number' || input.InputType == 'Time') {
              <input class="input" type="number" (change)="AddOrChangeValue(input.Key, $event)">
            }
            @if (input.InputType == 'Text') {
              <input class="input" type="text" (change)="AddOrChangeValue(input.Key, $event)">
            }
            @if (input.InputType == 'Boolean') {
              <app-toggleswitch (change)="AddOrChangeValue(input.Key, $event)"></app-toggleswitch>
            }
            @if (input.InputType == 'Select') {
              <div class="select">
                <select (change)="AddOrChangeValue(input.Key, $event)">
                  <option value="" disabled hidden selected> None Selected </option>
                  @for (inputOption of input.Options; track inputOption) {
                    <option [value]="inputOption.Value">{{inputOption.Name}}</option>
                  }
                </select>
              </div>
            }
          </div>
        </app-field>
      }
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary" (click)="confirm()">Confirm</button>
      <button class="button is-danger" (click)="close()">Cancel</button>
    </footer>
  </div>
</div>